if (!customElements.get('pp-forms-teaser')) {
  customElements.define('pp-forms-teaser', class extends HTMLElement {
    connectedCallback() {
      if (!/^\d+$/.test(this.dataset.formId)) return;
      this.sync = () => {
        const shadow = document.getElementById('app-embed-container-' + this.dataset.formId)?.shadowRoot;
        if (!shadow) return;
        if (this.shadow !== shadow) {
          this.shadowObserver?.disconnect();
          this.styles?.remove();
          this.shadow = shadow;
          this.styles = document.createElement('link');
          this.styles.rel = 'stylesheet';
          this.styles.href = this.dataset.styles;
          this.styles.dataset.ppFormsTeaser = '';
          shadow.append(this.styles);
          this.shadowObserver = new MutationObserver(this.sync);
          this.shadowObserver.observe(shadow, {childList:true, subtree:true});
        }
        const button = shadow.querySelector('[data-testid="form-teaser"]');
        const heading = button?.querySelector('h3');
        const label = this.dataset.label;
        if (heading && label && heading.textContent !== label) {
          heading.textContent = label;
          button.setAttribute('aria-label', label);
        }
      };
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(document.body, {childList:true, subtree:true});
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.shadowObserver?.disconnect();
      this.styles?.remove();
      this.shadow = null;
    }
  });
}
